import { useState } from "react";
import CustomButton from "../../../../../components/CustomButton";
import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import { OversizedPackagesDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";
import SvgIcon from "../../../../../helpers/SvgIcon";

function OversizedPackagesActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: OversizedPackagesDataInterface;
}) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleShowModal = () => setIsModalOpen(true);
  const onClose = () => setIsModalOpen(false);

  return (
    <>
      {crudData.imagini && crudData.imagini.length > 0 && (
        <div className="d-inline-block">
          <CustomButton
            variant="contained"
            className="mt-1 me-1 py-2"
            onClick={handleShowModal}
            tooltipTitle={`Vezi fotografii (${crudData.imagini.length})`}>
            <SvgIcon type="PICTURES" fill="white" />
          </CustomButton>

          <ModalWrapper
            show={isModalOpen}
            title={`Fotografii - AWB ${crudData.awb}`}
            modalSize="lg"
            handleClose={onClose}>
            <div className="container-fluid py-2">
              <div className="row g-4">
                {crudData.imagini.map((foto, idx) => (
                  <div key={idx} className="col-12 col-md-6">
                    <div className="card shadow-sm border border-secondary-subtle rounded-4 overflow-hidden bg-white h-100">
                      <div
                        className="position-relative bg-light"
                        style={{ height: "450px" }}>
                        <img
                          src={foto.url}
                          alt={`Incarcare ${idx}`}
                          className="w-100 h-100 d-block"
                          style={{ objectFit: "cover" }}
                          onError={(e) => {
                            (e.target as HTMLImageElement).src =
                              "https://placehold.jp/24/f8f9fa/6c757d/400x400.png?text=Imagine+Indisponibila";
                          }}
                        />

                        <div className="position-absolute top-0 end-0 m-3">
                          <a
                            href={foto.url}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-light shadow-sm d-flex align-items-center justify-content-center p-0"
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "50%",
                              lineHeight: "0",
                            }}
                            title="Deschide originalul">
                            <i
                              className="bi bi-arrows-fullscreen p-0"
                              style={{ fontSize: "1rem" }}></i>
                          </a>
                        </div>
                      </div>

                      <div className="card-body py-2 px-3 border-top">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="text-muted small">
                            <i
                              className="bi bi-calendar3 me-2"
                              style={{
                                color: "#2196F3",
                              }}
                            />
                            {getDateAndTime(foto.uploaded_at)}
                          </div>

                          {foto.problem && (
                            <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill px-3">
                              {foto.problem}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="px-3 pb-3 text-center">
              <CustomButton
                variant="outlined"
                className="mt-4"
                onClick={onClose}>
                Inchide
              </CustomButton>
            </div>
          </ModalWrapper>
        </div>
      )}
    </>
  );
}

export default OversizedPackagesActionButtons;
